/** @format */

import React from "react";
import "./whatGPT3.css";
import { Feature } from "../../components";

const WhatGPT3 = () => {
  return (
    <div className="what_gpt3 section_margin" id="wgpt3">
      <div className="what_gpt3_feature">
        <Feature title={"What is GPT-3"} text={"We so opinion friends me message as delight. Whole front do of plate heard oh ought. His defective nor convinced residence own. Connection has put impossible own apartments boisterous. At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by."} />
      </div>
      <div className="what_gpt3_heading gradient_text">
      <h1>The possibilities are beyond your imagination</h1>
      <p>Explore The Library</p>
      </div>
      <div className="what_gpt3_container">
      <Feature title={"Chatbots"} text={"We so opinion friends me message as delight. Whole front do of plate heard oh ought. "} />
      <Feature title={"Knowledgebase"} text={"At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b"} />
      <Feature title={"Education"} text={"At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b"}  />
      </div>
    </div>
  );
};

export default WhatGPT3;
